import { env } from '@/helpers/env'

export const config = {
  key: env('VUE_APP_AUTH_CLIENT_ID', 'missing-key'),
}
